export enum ExpenseMarkupType {
  MaterialHandling = 'MATERIAL_HANDLING',
  GeneralAdministration = 'GENERAL_ADMINISTRATION',
  None = "NONE"
}
